import React from 'react'
import { useSelector } from '../../modules/store/customSelector'
import styles from "./styles.module.scss"
import SalesText from '../../components/_atoms/SalesText/SalesText'
import { colors, fontSizes, fontWeights } from "../../constants/salesStyles"
import PayWallListItem from "../../components/_atoms/PayWallListItem/PayWallListItem"
import PayWallPhone from "../../components/_atoms/PayWallPhone/PayWallPhone"
import ErrorCar from "../../assets/img/error.svg"
import SalesButton from '../../components/_atoms/SalesButton/SalesButton'
import { adminRouteAlias, getAdminNavigationPath } from '../../router/adminRouteAlias'


const PayWall = () => {
    const paymentInfo = useSelector(state => state.userData.paymentInfo)
    
    const listItems = [
        'Функционал приложения ограничен, так как закончилась оплата подписки',
        'Временно отключена публикация объявлений на маркетплейсах и на витрине',
        'Процесс оплаты займет всего минуту',

    ]
    return (
        <div className={styles.wrap}>
            <div className={styles.imageAndContentWrap}>
                <img src={ErrorCar} alt="payWallCar"/>
                <div className={styles.contentWrap}>
                    <SalesText
                        text={'Оплатите подписку'}
                        fontSize={fontSizes.xxl}
                        fontWeight={fontWeights.bold}
                        color={colors.blueDark}
                        marginBottomPixels={40}

                    />
                    
                    {paymentInfo && (
                        <div className={styles.tariffInfo}>
                            <SalesText
                                text={`Ваш тариф ${paymentInfo.paymentRemark} – ${paymentInfo.paymentAmount} руб/мес`}
                                fontSize={fontSizes.l}
                                fontWeight={fontWeights.normal}
                                color={colors.blueDark}
                                marginBottomPixels={30}
                            />
                        </div>
                    )}
                    
                    <div>
                        {listItems.map((listItem: string) => (
                            <PayWallListItem
                                key={listItem}
                                text={listItem}
                            />
                        ))}
                    </div>
                    
                    {paymentInfo && paymentInfo.paymentLink ? (
                        <SalesButton
                            backgroundColor={colors.blueDark}
                            marginBottomPixels={20}
                            marginTopPixels={30}
                            paddingHorizontalPixels={20}
                            paddingVerticalPixels={7}
                        >
                            <a href={paymentInfo.paymentLink} target={"_blank"}>
                                <SalesText
                                    text={'Оплатить'}
                                    color={colors.white}
                                    fontSize={fontSizes.m}
                                />
                            </a>
                        </SalesButton>
                    ) : (
                        <SalesButton
                            backgroundColor={colors.blueDark}
                            marginBottomPixels={20}
                            marginTopPixels={30}
                            paddingHorizontalPixels={20}
                            paddingVerticalPixels={7}
                        >
                            <a href={getAdminNavigationPath(adminRouteAlias.billing.location)}>
                                <SalesText
                                    text={'Выбрать тариф'}
                                    color={colors.white}
                                    fontSize={fontSizes.m}
                                />
                            </a>
                        </SalesButton>
                    )}

                    <PayWallPhone />
                </div>
            </div>


        </div>
    )
}

export default PayWall
